import {
  ProductForApiSubmit,
  ProductForForm,
  ProductForUpdateApiSubmit,
  WARRANTY_TYPE,
} from 'types'

export const formatForm = (
  branchId: string,
  payload: ProductForForm,
): ProductForApiSubmit => {
  const warrantyType = payload.warrantyType.replace(
    /(^\w{1})|(\s+\w{1})/g,
    (letter) => letter.toUpperCase(),
  )

  delete payload.currentState

  const nextPayload: ProductForApiSubmit = {
    ...payload,
    branchId,
    warrantyPeriod: +payload.warrantyPeriod,
    maintenancePeriod: +payload.maintenancePeriod,
    warrantyType: warrantyType as WARRANTY_TYPE,
    isActive: Boolean(payload.isActive),
  }

  if (!payload.maintenancePeriod) {
    delete nextPayload.maintenancePeriod
    delete nextPayload.maintenanceUnit
  }

  if (!payload.warrantyPeriod) {
    delete nextPayload.warrantyPeriod
    delete nextPayload.warrantyUnit
  }

  if (!payload.startWarranty || !payload.endWarranty) {
    delete nextPayload.startWarranty
    delete nextPayload.endWarranty
  }

  if (payload.serialNumber === '') {
    nextPayload.serialNumber = null
  }

  return nextPayload
}

export const formatUpdate = (
  payload: ProductForApiSubmit,
): ProductForUpdateApiSubmit => {
  const nextPayload: Partial<ProductForApiSubmit> = payload

  delete nextPayload.skuId
  delete nextPayload.code
  delete nextPayload.name
  delete nextPayload.model
  delete nextPayload.currency
  delete nextPayload.price
  delete nextPayload.detail
  delete nextPayload.brand
  delete nextPayload.branchId

  if (payload.serialNumber === '') {
    nextPayload.serialNumber = null
  }

  return nextPayload as ProductForUpdateApiSubmit
}
